import React, {useEffect, useState} from "react";
import InitializePage from '../../../lib/server/page';
import Header from "../../../components/Layouts/Header";
import HomeFooter from '../../../components/Layouts/HomeFooter.jsx';
import Loader from '../../../components/loader';
import SubscribeNewsLetter from '../../../components/common/subscribenewsletter.jsx';
import LoginComponent from '../../../components/common/logincomponent.jsx';
import withAuthHOC from '../../../lib/withAuthHOC';

const Login = ({menu, webTexts}) => {
  const [isBackdropVisible, setBackdropVisibility] = useState(false);


  return (
    <>
        <Loader isBackdrop={isBackdropVisible} />
        <Header page={'common'} menuSections={menu}/>
        <LoginComponent path={'miespacio'}/>
        <div className="container line-container">
            <div className="line6"></div>
        </div>
        <SubscribeNewsLetter webTexts={webTexts} />
        <HomeFooter />
    </>
  );
}

async function loadData(context){                   
    return {};
}

export async function getStaticProps(context) {    
    return InitializePage(context,loadData, true)
}

export default withAuthHOC(Login);;
